function n(n){var t=!1;return{promise:new Promise((function(e,r){n.then((function(n){return!t&&e(n)})).catch((function(n){return!t&&r(n)}))})),cancel:function(){t=!0}}}export{n as default};
//# sourceMappingURL=index.js.map
